import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, GridApi } from 'ag-grid-community';
import { faAngleDown, faAngleRight, faEdit, faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-expand-edit-cell-renderer',
  templateUrl: './expand-edit-cell-renderer.component.html',
  styleUrls: ['./expand-edit-cell-renderer.component.scss']
})
export class ExpandEditCellRendererComponent implements ICellRendererAngularComp{
  // TO DO: SUPPRESS THE USUAL EDIT FUNCTIONS

  //added the fort? awesome icons
  faAngleDown = faAngleDown;
  faAngleRight = faAngleRight;
  faEdit = faEdit;
  faSave = faFloppyDisk;
  faCancel = faXmark;

  params!: ICellRendererParams;
  //rotation!: string;
  rotation: boolean = false;
  isEditing!: boolean;
  g!: GridApi;

  agInit(params: ICellRendererParams): void{
    this.params = params;
    this.isEditing = false;
    this.rotation = params.node.expanded;
    //this.rotation = params.node.expanded ? 'rotate(90deg)' : 'rotate(0deg)';
    this.g = params.api;

    this.params.node.addEventListener('expandedChanged', this.onExpand);
  }

  onExpand = () => {
    this.rotation = this.params.node.expanded;
    //this.rotation = this.params.node.expanded ? 'rotate(90deg)' : 'rotate(0deg';
  }

  onClickExpand(){
    this.params.node.setExpanded(!this.params.node.expanded);
  }


  refresh(params: ICellRendererParams){
    return true;
  }
}
